import { api } from '@creditsights/api-ui-web';

export interface GetConsentRequest {
  userId: string;
}

export interface GetConsentResponse {
  consentDate?: string;
  configuration: {
    id: string;
  };
}

export interface SaveConsentRequest {
  userId: string;
  configurationId?: string;
}

export const getConsent = async ({ userId }: GetConsentRequest): Promise<GetConsentResponse | undefined> => {
  const { data } = await api.get(`/profile/v1/profiles/${userId}/consents`);

  return data.find((item) => item.configuration.text === 'CS Genie consent');
};

export const saveConsent = async ({ userId, configurationId }: SaveConsentRequest): Promise<void> => {
  if (!configurationId) {
    throw new Error("Consent isn't provided");
  }

  await api.post(`/profile/v1/profiles/${userId}/consents`, {
    configurationId,
    consent: {
      message: 'Accepted consent thru v1 website',
      expired: false,
    },
  });
};
